
















import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
import Validatable from '@/mixins/Validatable'
import Focusable from '@/mixins/Focusable'
import config from '@/config'

@Component
export default class DntSendBlock extends Mixins(Vue, Validatable, Focusable) {
	@Prop({ default: false }) readonly value!: boolean

	private get labelText() {
		if (!config.dntSendToThirdParties) return null
		return config.dntSendToThirdParties.label
	}

	get checkboxState() {
		return typeof this.errorMsg !== 'string' ? null : false
	}

	get checked() {
		return this.value
	}

	set checked(value: boolean) {
		this.$emit('input', value)
	}

	@Watch('value')
	onValueChanged() {
		this.validate()
	}

	onChange() {
		this.$emit('input', !this.value)
	}
}
